module.exports = __webpack_public_path__ + "Logo 2.6392ad24.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/2018/landing/Logo 2.png
// module id = D8N8
// module chunks = 0